import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.number.to-fixed";
import "core-js/modules/web.dom-collections.for-each";
import _toConsumableArray from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { tabulation } from "@/mixins/index";
import { activityDevireRoiCurrencyOther } from "@/api/dataAll/roi";
import * as echarts from "echarts";
export default {
  name: "roiacde",
  mixins: [tabulation],
  data: function data() {
    return {
      value2: [],
      searchData: {
        starttime: "",
        endtime: "",
        country: "",
        self_design_day: "",
        kind: 1
      },
      tableData: [],
      cyclicData: [],
      dates: [],
      datas: [],
      series: [],
      cellStylekeys: ["roiAndrecharge"]
    };
  },
  created: function created() {},
  methods: {
    searchClickNs: function searchClickNs() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var reqFn;
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                reqFn = activityDevireRoiCurrencyOther;
                _this.reqLoading = true;
                _context.next = 4;
                return _this.getexchangeRate();

              case 4:
                _this.searchClickPoints(reqFn, 1);

              case 5:
              case "end":
                return _context.stop();
            }
          }
        }, _callee);
      }))();
    },
    searchClick: function searchClick(list) {
      var _this2 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var res, newData, i, roiList, rechargeList, k, _loop, _k;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                res = {
                  data: {
                    cost: {},
                    recharge: {},
                    recharge_all: {},
                    roi: {}
                  }
                };
                list.forEach(function (i) {
                  for (var k in res.data) {
                    res.data[k] = _objectSpread(_objectSpread({}, res.data[k]), i[k]);
                  }
                });
                _this2.dates = [];
                _this2.series = [];
                _this2.cyclicData = [];
                _this2.datas = [];
                _this2.tableData = [];
                _context2.next = 9;
                return _this2.timeInterval();

              case 9:
                newData = JSON.parse(JSON.stringify(res.data));

                for (i in newData.roi) {
                  roiList = [];
                  rechargeList = [];

                  for (k in newData.roi[i]) {
                    roiList.push({
                      label: k,
                      value: newData.roi[i][k]
                    });
                    rechargeList.push({
                      label: k,
                      value: newData.recharge[i][k]
                    });
                  }

                  newData.roi[i] = roiList;
                  newData.recharge[i] = rechargeList;
                }

                _loop = function _loop(_k) {
                  var data = {
                    date: _k,
                    cost: _this2.$utils.conversion(newData.cost[_k]),
                    recharge_all: _this2.isyjfmvnd() ? newData.recharge_all[_k] : _this2.$utils.conversion(newData.recharge_all[_k]),
                    exchange: _this2.isyjfmvnd() ? newData.recharge_all[_k] * _this2.exchangeRate : _this2.$utils.conversion(newData.recharge_all[_k] * _this2.exchangeRate).toFixed(2)
                  };

                  _this2.dates.push(_k);

                  newData.roi[_k].map(function (item, index) {
                    var n = item.label;
                    data["roiAndrecharge" + n] = Number(item.value).toFixed(3) + " / " + (_this2.isyjfmvnd() ? newData.recharge[_k][index].value : _this2.$utils.conversion(newData.recharge[_k][index].value).toFixed(3));
                    data["roi" + n] = item.value;

                    if (_this2.cyclicData.length < newData.roi[_k].length) {
                      var headerLabel = _this2.$t('roiSlashRecharge', {
                        day: item.label
                      });

                      _this2.cyclicData.push({
                        label: headerLabel,
                        prop: "roiAndrecharge" + n,
                        desc: n == 0 ? _this2.$t('firstDayRoi') : "",
                        tableText: n == 0 ? headerLabel + 'A' : headerLabel
                      });

                      _this2.datas.push("roi" + item.label);
                    }
                  });

                  _this2.series.push({
                    name: _k,
                    type: "line",
                    data: newData.roi[_k].map(function (i) {
                      return Number(i.value).toFixed(3);
                    }),
                    smooth: true
                  });

                  _this2.tableData.push(data);
                };

                for (_k in newData.roi) {
                  _loop(_k);
                }

                _this2.$nextTick(function () {
                  _this2.getechart();

                  _this2.getTableRight();
                });

              case 14:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    },
    getechart: function getechart() {
      var chartDom = document.getElementById("roiacdeEchart");
      var myChart = echarts.init(chartDom);
      var option;
      var dates = this.dates;
      var datas = this.datas;
      var series = this.series;
      option = {
        title: {
          text: "ROI"
        },
        animationDuration: 3000,
        tooltip: {
          confine: true,
          trigger: "axis"
        },
        legend: {
          data: dates,
          // selected: this.selectedArr,
          width: "80%"
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true
        },
        toolbox: {
          z: 12,
          feature: {
            saveAsImage: {}
          }
        },
        xAxis: {
          type: "category",
          nameLocation: "middle",
          data: datas
        },
        yAxis: {
          type: "value"
        },
        series: series
      };
      option && myChart.setOption(option, true);
    },
    handleCurrentChange: function handleCurrentChange(val) {
      this.searchData.page = val;
      this.page = val;
      this.searchClick();
    },
    exportdata: function exportdata() {
      var columns = [{
        label: this.$t('dateSlashDate'),
        prop: "date"
      }, {
        label: this.$t('rechargeAllSlashEarnings'),
        prop: "recharge_all"
      }, {
        label: this.$t('costSlashPay'),
        prop: "cost"
      }].concat(_toConsumableArray(this.cyclicData));
      var exchangeUSD = JSON.parse(JSON.stringify(this.exchangeUSD));
      var exchangeVND = JSON.parse(JSON.stringify(this.exchangeVND));

      if (this.queryCurrency == "USD") {// exchangeUSD.unshift(2, 0);
        // Array.prototype.splice.apply(columns, exchangeUSD);
      }

      if (this.queryCurrency == "VND") {
        exchangeVND.unshift(2, 0);
        Array.prototype.splice.apply(columns, exchangeVND);
      }

      this.$export.excel({
        columns: columns,
        data: this.tableData,
        title: this.$route.meta.title
      });
    }
  }
};